// extracted by mini-css-extract-plugin
export default {"root":"style_root__nM8+c","mapContainer":"style_mapContainer__VUKsW","map":"style_map__Zhivc","restaurantsListContainer":"style_restaurantsListContainer__ROXzG"};